import React, { FC } from 'react';
import { View } from 'react-native';
import { scale } from '@components/frame';
import { ActionArrow } from '@components/common/ActionArrow';
import { TOP_BLOCK_CONFIG } from '@v2/pages/machines/modules/now/components/Overview/constants';
import LinkIconWithInfo from './LinkIconWithInfo';
import AdditionalLinkInfo from './AdditionalLinkInfo';
import NCFileName from './NCFileName';
import { BaseTopBlockProps, NCFileNameProp } from '@v2/pages/machines/modules/now/components/Overview/components/TopBlock/types';

interface TopBlockHeaderProps extends BaseTopBlockProps, Partial<NCFileNameProp> {
  showActionArrow?: boolean;
  gapCompensation?: number;
}

const TopBlockHeader: FC<TopBlockHeaderProps> = ({ C, ncFileName, showActionArrow = false, gapCompensation = 0 }) => {
  const { paddingVertical, ncFileNamePaddingBottom } = TOP_BLOCK_CONFIG;

  return (
    <>
      <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
        <LinkIconWithInfo containerStyle={{ flex: 1 }} />
        {showActionArrow && <ActionArrow stylesToReplace={{}} />}
      </View>

      {ncFileName !== undefined && (
        <View
          style={{
            paddingTop: scale(paddingVertical - gapCompensation),
            paddingBottom: scale(ncFileNamePaddingBottom - gapCompensation),
          }}
        >
          <NCFileName ncFileName={ncFileName} C={C} />
        </View>
      )}

      <AdditionalLinkInfo />
    </>
  );
};

export default TopBlockHeader;
